define('shared/lib/validate',['shared/lib/RSVP', './validate.source'], function( RSVP, validate ){
    'use strict';
    validate.Promise = RSVP.Promise;
    return validate;
} ); 

